// extracted by mini-css-extract-plugin
export var box = "_3n-2";
export var checkboxControl = "_3n-0";
export var checkboxRow = "_3n-a";
export var checked = "_3n-3";
export var descriptionSpacer = "_3n-c";
export var disabled = "_3n-4";
export var icon = "_3n-8";
export var input = "_3n-1";
export var labelSpacer = "_3n-b";
export var large = "_3n-7";
export var medium = "_3n-6";
export var small = "_3n-5";
export var text = "_3n-9";